import { ReactNode } from 'react';

import { Route, RouteObject } from 'react-router-dom';

export const renderRoutes = ({ path, element, children, id = '' }: RouteObject): ReactNode => (
  <Route
    path={path}
    element={element}
    key={`route__${path}__${id}`}
    children={children?.map(renderRoutes)}
  />
);
